import Repository from "./Repository";

const resource = "/Notification";

export default {
  get({
    page = 1,
    pageSize = 30,
    sortField = "createdDate",
    sortType = "desc",
    searchQuery = "",
    equipe = null,
    statut = null,
    cancelToken = null
  }) {
    return Repository.post(
      `${resource}/Search`,
      {
        pageNumber: page,
        pageSize,
        sortField,
        sortType
      },
      {
        cancelToken,
        params: {
          criteria: searchQuery !== null ? searchQuery : "",
          equipe: equipe,
          statut: statut
        }
      }
    ).then(res => {
      if (res.data && res.data.content && res.data.content.list) {
        res.data.content.list = res.data.content.list.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        );
      }
      return res;
    });
  },
  validation({ items = [] }) {
    return Repository.post(
      `${resource}/Validation`,
      items.map(notification => notification.id)
    );
  },
  cancelValidation({ items = [] }) {
    return Repository.post(
      `${resource}/CancelValidation`,
      items.map(notification => notification.id)
    );
  }
};
